module.exports = {
          srcSet: __webpack_public_path__ + "fe06327849c62a57f9f96c250b6c46ae-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "fe06327849c62a57f9f96c250b6c46ae-1168.png",width: 1168,height: 198}],
          src: __webpack_public_path__ + "fe06327849c62a57f9f96c250b6c46ae-1168.png",
          toString:function(){return __webpack_public_path__ + "fe06327849c62a57f9f96c250b6c46ae-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ACMiJ/04ODz/ODk9/kJCR/8zNz3/MCYp/8FrSf9oPij+SkE0/049MvsAGBgd9SYlKv8kJCr+LCwx/ycqMv81LSb/plo4/2U8Mf6yjVH/sIsz8024IxNFOpm3AAAAAElFTkSuQmCC",
          width: 1168,
          height: 198
        }